import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { ChartModule } from 'primeng/chart';

export interface TaskChartData {
  date: string;
  count: number;
}

@Component({
  selector: 'app-tasks-chart-widget',
  standalone: true,
  imports: [CommonModule, CardModule, SkeletonModule, ChartModule],
  templateUrl: './tasks-chart-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TasksChartWidget {
  data = input<TaskChartData[]>([]);
  loading = input<boolean>(false);

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false
        }
      },
      y: {
        display: true,
        beginAtZero: true,
        ticks: {
          stepSize: 1
        },
        grid: {
          color: 'rgba(0,0,0,0.1)'
        }
      }
    }
  };

  getTotalTasks(): number {
    return this.data().reduce((sum, item) => sum + item.count, 0);
  }

  get chartData() {
    const chartData = this.data();
    return {
      labels: chartData.map(item => {
        const date = new Date(item.date);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }),
      datasets: [{
        label: 'Tasks',
        data: chartData.map(item => item.count),
        backgroundColor: '#3B82F6',
        borderColor: '#3B82F6',
        borderWidth: 1,
        borderRadius: 1,
        borderSkipped: false
      }]
    };
  }
}
